"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var content_exports = {};
__export(content_exports, {
  client: () => client,
  urlFor: () => urlFor
});
module.exports = __toCommonJS(content_exports);

// images/images.ts
var import_image_url = __toESM(require("@sanity/image-url"));

// sanity-client/sanity-client.ts
var import_client = __toESM(require("@sanity/client"));
var config = {
  projectId: "0jcqmme0",
  dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
  apiVersion: "v2021-03-25",
  useCdn: false
};
var client = (0, import_client.default)(config);

// images/images.ts
var builder = (0, import_image_url.default)(client);
function urlFor(source) {
  return builder.image(source).format("webp");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  client,
  urlFor
});
